export { isConflictError, RETAKE_UNAVAILABLE_MESSAGE } from './errors';
export {
  RoleProvider,
  useCandidateRoles,
  useRoleContext,
} from './role-context';
export type { RoleOutcome, RoleStepsDone } from './role-steps';
export {
  countRoleStepsDone,
  getRoleListRank,
  getRoleOutcome,
  getRoleStepsDone,
  ROLE_STEP_COUNT,
  RoleStepKey,
} from './role-steps';
export type { CandidateRole, JourneyRole } from './role-types';
export {
  canBookHardSkills,
  canBookInterviewType,
  canBookScreening,
  formatScheduledSlot,
  formatSlot,
  getSentInterviewLink,
  getSentScreeningLink,
  hasBookedInterview,
  hasVerificationOutcome,
  isCallCompleted,
  isInterviewCleared,
  isRolePaused,
  isRoleVerified,
  isTestCompleted,
  NO_INTERVIEW_SLOTS_MESSAGE,
} from './role-types';
export type { BookingLauncher } from './use-booking-launcher';
export { useBookingLauncher } from './use-booking-launcher';
export type { TestLauncher } from './use-test-launcher';
export { useTestLauncher } from './use-test-launcher';
export {
  CandidateRoleCallStatus,
  CandidateRoleCategory,
  CandidateRoleInterviewStatus,
  CandidateRoleInterviewType,
  CandidateRoleReviewStatus,
  CandidateRoleScreeningStatus,
  CandidateRoleSeniority,
  CandidateRoleTestStatus,
  CandidateRoleVerificationOutcome,
} from '@internal/api/roles/roles';
